<template>
  <div>
    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-container v-if="dataloaded && userDataLoaded"  grid-list-md class="ma-0 pa-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !this.demoMode">
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadMedicalIntakeData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex  md9 xs12>

        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="dataloaded && userDataLoaded && !deleting && medicalIntakes.length > 0" class="mt-5">
      <div class="content-box">
        <div>
          <v-btn v-for="year in yearsToSelect" class="ma-2" :key="year" color="primary" :outlined="year != selectedYear" @click="loadMedicalIntakeData(year)">{{ year }}</v-btn>
        </div>
        <v-card>
          <v-card-title>
            <v-text-field
              style="max-width: 300px;"
              v-model="search"
              :color="companyPrimaryColor"
              placeholder="Zoeken"
              outlined
              hide-details     
              background-color="#fff"                                                
              prepend-inner-icon="search"
              autocomplete="disabled"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
            <div class="header-edit-button">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" fab darken color="primary" @click="addNewMedicalIntake()">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </template>
                <span style="color: #fff;">Medische intake</span>
              </v-tooltip>
            </div>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="medicalIntakes"
            :search="search"
            :itemsPerPage.sync="queuePages"
            v-model="selected"
            show-expand
            single-expand
            hide-default-footer

            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item, isExpanded, expand}">
              <tr>
                <td>{{ item.dateAddedFormatted }}u</td>
                <td>{{ item.firstName }} {{ item.lastName }}</td>     
                <td class="text-center"><v-chip v-if="item.feedback.questions && item.feedback.questions.length > 0" small :color="getColor(item.feedback.questions.length)" dark><strong>{{ item.feedback.questions.length }}</strong></v-chip><v-chip v-else small color="#43A047" dark><strong>0</strong></v-chip></td>
                <td class="text-center"><v-chip v-if="item.feedback.analyse && item.feedback.analyse.length > 0" small :color="getColor(item.feedback.analyse.length)" dark><strong>{{ item.feedback.analyse.length }}</strong></v-chip><v-chip v-else small color="#43A047" dark><strong>0</strong></v-chip></td>
                <td>{{ getBranchName(item.branch) }}</td>
                <td>
                  <v-tooltip v-if="!isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Meer informatie tonen</span>
                  </v-tooltip>

                  <v-tooltip v-if="isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Meer informatie verbergen</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0;">
                <v-card flat>
                  <v-card-text>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <b>Feedback:</b><br>
                        <h2>Uitkomst vragenlijst</h2>
                        <div v-if="item.feedback.questions.length > 0">
                          <div v-for="(feedback, index) in item.feedback.questions" :key="index" class="py-2">
                              <span v-html="feedback"></span>
                          </div>
                        </div>
                        <div v-if="item.feedback.questions.length== 0" class="py-2">
                          <p>Je hebt geen extra risico op haaruitval of afbrekend haar. </p>
                        </div>

                        <h2>Uitkomst Analyse</h2>
                        <div v-if="item.feedback.analyse.length > 0">
                          <div v-for="(feedback, index) in item.feedback.analyse" :key="index" class="py-2 feedback">
                              <span v-html="feedback"></span>
                          </div>
                        </div>
                        <div v-if="item.feedback.analyse.length == 0" class="py-2">
                          <p>Geen extra bijzonderheden</p>
                        </div>

                      </v-flex>
                      <v-flex xs4>
                        <b>Handtekening:</b><br>
                        <v-img width="250px" :src="item.clientSignature"></v-img>
                      </v-flex>
                    </v-layout>
      
                  </v-card-text>
                </v-card>
              </td>
            </template>
          </v-data-table>
        </v-card>

      </div>
    </div>

    <div style="width: 350px; margin: 50px auto;" class="text-center" v-if="dataloaded && userDataLoaded && !deleting && medicalIntakes.length == 0">
      <p>Er zijn geen medische intakes ingevuld</p>
      <div class="text-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab darken color="primary" style="display: block; margin: 15px auto;" @click="addNewMedicalIntake()">
              <v-icon darken>add</v-icon>
            </v-btn>
          </template>
          <span style="color: #fff;">Voeg een nieuwe medische intake toe. </span>
        </v-tooltip>
      </div>
    </div>

    <!-- / Medical Intake Dialog \ -->
    <add-medical-intake-form :activeCompData="activeCompData" @updateData="updateData()"></add-medical-intake-form>
    <!-- \ Medical Intake Dialog / -->

  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import _lodash from "lodash";
import AddMedicalIntakeForm from "../components/modals/AddMedicalIntakeForm.vue";
import platform from 'platform'; 
import moment from 'moment';
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
// import pdfMake from 'pdfmake'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export default {
  components: {
    "add-medical-intake-form": AddMedicalIntakeForm,
  },
  name: "Medical intakes",
  data: () => ({
    activeComp: null,
    activeCompData: null,
    userDataLoaded: false,
    selectedBranchesOriginal: [],
    selectedBranches: [],
    selectedBranchesData: [],
    search: "",
    searchCompanies: "",
    selected: [],
    deleting: false,
    deleteCounter: 0,
    dataloaded: false,
    newQueueDialog: false,
    editQueueDialog: false,
    selectedClientQueueItem: {
      name: "",
      phone: "",
      treatment: "",
      branch: "",
      employee: "",
      salonhubId: "",
      queueEndDate: "",
      queueEndDateMoment: "",
      treatmenTime: "",
    },
    pagination: {
      rowsPerPage: "200",
      sortBy: "dateAdded.seconds",
      descending: false
    },
    medicalIntakes: [],
    medicalIntakesScheduled: [],
    selectedClientQueueItemOriginal: {},
    removeBookings: "",
    selected: [],
    branches: [],
    companies: [],
    queuePages: -1,
    headers: [
      {
        text: "Datum",
        align: "left",
        value: "dateAdded",
        width: "200px"
      },
      {
        text: "Naam",
        align: "left",
        value: "lastName"
      },
      {
        text: "Vragenlijst",
        align: "center",
        value: "feedback.questions.length",
        width: "150px"
      },
      {
        text: "Analyse",
        align: "center",
        value: "feedback.analyse.length",
        width: "150px"
      },
      {
        text: "Vestiging",
        align: "left",
        value: "branch"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "50px",
        sortable: false
      },
    ],
    selectedYear: null,
    yearsToSelect: [],
    previewMembershipDialog: false,
    previewMembership: new Object(),
    membershipTypes: [
      {
        id: "new",
        name: 'Nieuw (3 maanden)'
      },
      {
        id: "extension",
        name: 'Verlenging (3 maanden)'
      },
      {
        id: "newFour",
        name: 'Nieuw (4 maanden)'
      },
      {
        id: "extensionFour",
        name: 'Verlenging (4 maanden)'
      }
    ],
  }),

  created() {
    this.loadUserComp();

    const currentYear = new Date().getFullYear();
    for (let year = 2023; year <= currentYear; year++) {
      this.yearsToSelect.push(year);
    }
    this.yearsToSelect.reverse();
    this.selectedYear = this.yearsToSelect[0];
  },

  methods: {
    loadUserComp() {
      this.dataloaded = false;
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let dossierPackage = _.indexOf(doc.data().packages, 'dossier')
              if (dossierPackage >= 0) {
                let company = doc.data();
                company.id = doc.id;
                this.companies.push(company);
              }
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        
        
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeCompData = this.companies[selectedCompanyIndex];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              console.log("selectedCompanyIndex: ", selectedCompanyIndex)
              this.loadBranches();
              this.loadMedicalIntakeData();
              this.userDataLoaded = true;
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeCompData = this.companies[0];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadBranches();
              this.loadMedicalIntakeData();
              this.userDataLoaded = true;
            }
            
          }
          // No selected company is set 
          else {
            this.activeCompData = this.companies[0];
            this.activeComp = this.companies[selectedCompanyIndex].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadBranches();
            this.loadMedicalIntakeData();
            this.userDataLoaded = true;

          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeCompData = this.companies[0];
          this.activeComp = this.companies[0].id;
          this.loadMedicalIntakeData();
          this.userDataLoaded = true;
        }
      })
      
    },

    loadBranches() {
      if(this.companies.length > 1){
        this.companies.forEach(company => {
          if(company.id == this.activeComp){
            this.activeCompData = company;
          }
        });
      }
      console.log("this.activeComp: ", this.activeComp)
      db.collection("branches")
      .where("compId", "==", this.activeComp)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let branchCollection = doc.data();
          branchCollection.id = doc.id;
          this.branches.push(branchCollection);
        });
      })
    },

    getBranchName(branch){
      let name = '';
      this.branches.forEach(element => {
        if(element.id == branch){
          name = element.branchName
        }
      });
      return name;
    },   

    getColor(number){
      if(number > 2){
        return "#B71C1C";
      }
      else if(number == 2){
        return "#FF5722";
      }
      else{
        return "#FDD835";
      }
    },


    updateData(){
      this.dataloaded = false;
      this.loadMedicalIntakeData();
    },

    async loadMedicalIntakeData(year){
      this.dataloaded = false;
      let useYear = year ? year : moment().format("YYYY");
      this.selectedYear = useYear;
      this.memberships = new Array();
      let start = moment(useYear,"YYYY").startOf('year').format("YYYY-MM-DD");
      let end = moment(useYear,"YYYY").endOf('year').format("YYYY-MM-DD");

      this.medicalIntakes = new Array();
      await db.collection("intakes")
      .where("companyId", "==", this.activeComp)
      .where("signDate", ">=", start)
      .where("signDate", "<=", end)
      .orderBy("signDate", "desc")
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let medicalIntake = doc.data();
          medicalIntake.dateAddedFormatted = moment(doc.data().dateAdded.seconds, "X").format("D MMM YYYY H:mm")
          medicalIntake.id = doc.id;
          this.medicalIntakes.push(medicalIntake);
        });
      })
      this.dataloaded = true;
    },


    addNewMedicalIntake(){
      bus.$emit("openMedicalIntakeDialog");
    },

    goToDossier(salonhubId){
      this.$router.push('/dossier?id='+ salonhubId)
    },
  },

  computed: {
    demoMode(){
      return this.$store.state.demoMode;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userBranches() {
      return this.$store.state.userBranches;
    }, 
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    branchesChanged() {
      if (
        _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    branchesWidth(){
      if(this.companies.length > 1 && !this.demoMode){
        return "md6"
      }
      else{
        return "md9"
      }
    }
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}

.feedback h3{
  padding: 0!important;
  border: none!important
}
</style>
